import {UserDto} from '@domain/pom'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {QueryKeyName, getPomUsers} from '../../common/backend'
import {usePlantUpmId} from '../usePlantUpmIdContext'

export const usePomUsers = (namePattern: string, enabled: boolean) => {
  const plantId = usePlantUpmId()
  return useQuery<UserDto[], AxiosError>({
    queryKey: [QueryKeyName.GetPomUsers, namePattern, plantId],
    queryFn: () => getPomUsers({namePattern, plantId}),
    enabled
  })
}
